/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraResourceTrendSummaryRequest extends models.InfraResourceTrendRequestBase {
    getFixupPrototypeFunction() { return InfraResourceTrendSummaryRequest.fixupPrototype; }

    static newInstance(model: Partial<InfraResourceTrendSummaryRequest>): InfraResourceTrendSummaryRequest {
        let obj = Object.assign(new InfraResourceTrendSummaryRequest(), model);
        InfraResourceTrendSummaryRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraResourceTrendSummaryRequest>): InfraResourceTrendSummaryRequest {
        if (!model) return null;
        return InfraResourceTrendSummaryRequest.newInstance(<InfraResourceTrendSummaryRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraResourceTrendSummaryRequest) {
        if (!obj) return;

        models.InfraResourceTrendSummaryRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraResourceTrendSummaryRequest): boolean {
        if (models.InfraResourceTrendRequestBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, InfraResourceTrendSummaryRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.filters) {
            models.InfraResourceTrendSummaryBaseFilters.fixupPrototype(this.filters);
        }
    }

    /**
     * Filters applied to the trend data.
     */
    filters: models.InfraResourceTrendSummaryBaseFilters;

    /**
     * Granularity for aggregating resource trend data
     */
    granularity: models.InfraIssuesTrendGranularity;

    /**
     * Grouping criteria for the trend data.
     */
    group_by: models.InfraResourceTrendGroupBy;

}
